export default __webpack_public_path__ + "static/media/Mercenary's Vest of Pierced Flesh.5aec8493.jpg";